import React from "react";
import { BackgroundImage, HeaderComponent, ContactTabs } from "../../FifthComponents";
import img from "../../fifthAssets/Images/contact-img.jpg"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import allPaths from "../../Config/paths"

const FifthContact = (props) => {
    const { selectedLanguage } = props;
    const history = useHistory()
    return (
        <div>
            <BackgroundImage screenName={selectedLanguage?.txt_contact_} classForBg='fifth-des-news-bg' {...props}/>
            <HeaderComponent title={selectedLanguage?.txt_contact_} lineClass='bg-gray' titleClass='color-blue' />
            <div className="fifth-des-contact-div">
                <div className="fifth-des-contact-tabs-div">
                    <ContactTabs {...props}/>
                </div>
                <div className="fifth-des-contact-img-div" onClick={()=> history?.push(allPaths?.FIFHTAPPOINTMENT)}>
                    <img src={img} alt="" />
                </div>
            </div>
        </div>
    )
}
export default FifthContact